import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import dayjs from 'dayjs';

// Helper for experience-list type
function formatExperienceList(answer) {
  let items = [];
  if (typeof answer === 'string') {
    try { items = JSON.parse(answer); } catch { return '-'; }
  } else if (Array.isArray(answer)) {
    items = answer;
  }
  if (!items.length) return '-';
  return items.map((exp, idx) =>
    `${idx + 1}) ${exp.jobTitle || '-'} at ${exp.companyName || '-'}\n` +
    `   Dates: ${exp.startDate ? dayjs(exp.startDate).format('YYYY-MM-DD') : '-'} - ${exp.endDate ? dayjs(exp.endDate).format('YYYY-MM-DD') : '-'}\n` +
    `   Reason: ${exp.reasonForLeaving || '-'}\n` +
    `   Responsibilities: ${exp.responsibilities || '-'}\n`
  ).join('\n');
}

function formatSeparatedList(answer) {
  if (!answer) return '-';
  if (Array.isArray(answer)) return answer.join(', ');
  return answer.split(/,+/).map(v => v.trim()).filter(Boolean).join(', ');
}

function getAbsoluteUrl(url, baseUrl) {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (!baseUrl) return url;
  if (url === '/') return '';
  return `${baseUrl.replace(/\/$/, '')}${url.startsWith('/') ? '' : '/'}${url}`;
}

function getAttachmentLinks(attachments, baseUrl) {
  if (!attachments?.data) return [];
  const files = Array.isArray(attachments.data) ? attachments.data : [attachments.data];
  return files
    .filter(file => file?.attributes?.url)
    .map(file => ({
      name: file.attributes.name,
      url: getAbsoluteUrl(file.attributes.url, baseUrl)
    }));
}

export function jobApplicationPdfGenerator(data, baseUrl = 'https://mishov-blog.hel1.your-objectstorage.com') {
  if (!data || !data.attributes?.questionsAndAnswers) return;

  const doc = new jsPDF();

  const { fullName, createdAt } = data.attributes;
  doc.setFontSize(16);
  doc.text(`${fullName || 'Applicant'} - Application Details`, 14, 18);

  doc.setFontSize(10);
  doc.text(`Created At: ${createdAt ? dayjs(createdAt).format('YYYY-MM-DD HH:mm') : '-'}`, 14, 26);

  const questionsAndAnswers = data.attributes.questionsAndAnswers;

  const tableRows = [];
  const linkCells = [];

  questionsAndAnswers.forEach((qa, idx) => {
    let ans = "-";
    if (qa.type === "file") {
      const links = getAttachmentLinks(qa.attachments, baseUrl);
      if (links.length) {
        ans = ' '; // Leave cell visually empty; link drawn by didDrawCell
        linkCells.push({
          row: idx,
          col: 2, // Answer/Attachment column
          urls: links
        });
      } else {
        ans = '-';
      }
    } else if (qa.type === "date") {
      ans = qa.answer ? dayjs(qa.answer).format('YYYY-MM-DD') : '-';
    } else if (qa.type === "separated-list") {
      ans = formatSeparatedList(qa.answer);
    } else if (qa.type === "experience-list") {
      ans = formatExperienceList(qa.answer);
    } else {
      ans = qa.answer || '-';
    }
    tableRows.push([idx + 1, qa.question, ans]);
  });

  autoTable(doc, {
    head: [['#', 'Question', 'Answer / Attachment']],
    body: tableRows,
    startY: 32,
    headStyles: { fillColor: [0, 22, 106] },
    styles: { fontSize: 9, cellWidth: 'wrap' },
    columnStyles: {
      0: { cellWidth: 12 },
      1: { cellWidth: 80 },
      2: { cellWidth: 95 }
    },
    didDrawCell: function (data) {
      const cellLink = linkCells.find(link => link.row === data.row.index && link.col === data.column.index);
      if (cellLink && cellLink.urls) {
        let y = data.cell.y + 6;
        cellLink.urls.forEach((linkObj, idx) => {
          doc.setTextColor(22, 95, 171);
          doc.textWithLink(
            linkObj.name,
            data.cell.x + 4,
            y + idx * 6,
            { url: linkObj.url }
          );
          doc.setTextColor(0, 0, 0);
        });
      }
    }
  });

  doc.save(`${fullName?.replace(/\s+/g, '_') || 'application'}_questions.pdf`);
}
